import React, { useEffect, useState } from "react";
import general from "../../general";
import Dialog from "../../lib/Dialog";
import Image from "../../lib/Image";
import { Link } from "react-router-dom";
import { Badge, ActionSheet, Modal } from 'antd-mobile'
import './comments/css/message.css'

export default props => {
  useEffect(() => {
    props.setOperate(<div onClick={handleEdit}>编辑</div>)
  }, []);

  const [visible, setVisible] = useState(false)
  const [loaded, setLoaded] = useState(false);
  const [list, setList] = useState([]);

  const handleEdit = () => {
    setVisible(true)
  }

  const actions = [
    {
      text: '一键已读', key: 'edit', onClick: async () => {
        oneClickOperateMess(1)
      }
    },
    {
      text: '一键删除', key: 'save', onClick: async () => {
        deleteAlert()
      },
    },
  ]

  const deleteAlert = () => {
    Modal.show({
      title: '温馨提示',
      closeOnMaskClick: true,
      className: 'game-sign-title',
      content: (
        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
          <div style={{ fontSize: 12, color: '#666', padding: 5 }}>确认删除吗?</div>
          <div onClick={() => {
            oneClickOperateMess(2)
            Modal.clear()
          }} style={{ backgroundColor: 'var(--MainColor)', width: '183px', height: '44px', color: 'white', fontSize: '15px', textAlign: 'center', borderRadius: '22px', lineHeight: '44px', marginTop: '10px' }}>确认</div>
          <div onClick={() => {
            Modal.clear()
          }} style={{ fontSize: '13px', color: '#999', paddingTop: '10px' }}>取消</div>
        </div>
      ),
    })
  }

  const oneClickOperateMess = (operate_type) => {
    general.axios.post('/oneClickOperateMess', {
      general_type: 'all',
      operate_type
    }).then(res => {
      let { status, data } = res.data;
      setTimeout(() => {
        if (operate_type == 2){
          Dialog.success('删除成功');
        }
      }, 300);
      load()
    })
  }

  const load = () => {
    if (!loaded && list.length == 0) {
      Dialog.loading();
    }
    general.axios.post('mess_index_data_entry')
      .finally(() => {
        Dialog.close();
      })
      .then(res => {
        let { status, data } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
          return;
        }
        setList(data)
        setLoaded(true);
      })
      .catch(err => {
        Dialog.error(err.message);
      });
  };
  useEffect(() => {
    props.active && load();
  }, [props.active]);

  return <div className="message-index" style={{ display: loaded ? 'block' : 'none' }}>
    <div className="message-group">
      {list.map(group => <Link to={'/message/list' + '?type=' + group.type} className="item">
        <div className="icon"><Image src={'/resources/251009/' + group.type + '.png'} alt="" /></div>
        <div className="info">
          <div className="name">{group.title}</div>
          {parseInt(group.message_total) > 0 ? <div className="data">您有新的消息通知</div> : <div className="empty">暂无新消息通知</div>}
        </div>
        {group.message_total > 0 && <Badge content={parseInt(group.message_total) > 99 ? '99+' : group.message_total}></Badge>}
      </Link>)}
    </div>
    <ActionSheet
      cancelText='取消'
      popupClassName='message-action-sheet'
      getContainer={document.getElementById('root')}
      closeOnAction={true}
      visible={visible}
      actions={actions}
      onClose={() => setVisible(false)}
    />
  </div>;
};